/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFacilityCustomTagRequest
 */
export interface CreateFacilityCustomTagRequest {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the CreateFacilityCustomTagRequest interface.
 */
export function instanceOfCreateFacilityCustomTagRequest(value: object): value is CreateFacilityCustomTagRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    return true;
}

export function CreateFacilityCustomTagRequestFromJSON(json: any): CreateFacilityCustomTagRequest {
    return CreateFacilityCustomTagRequestFromJSONTyped(json, false);
}

export function CreateFacilityCustomTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFacilityCustomTagRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function CreateFacilityCustomTagRequestToJSON(json: any): CreateFacilityCustomTagRequest {
    return CreateFacilityCustomTagRequestToJSONTyped(json, false);
}

export function CreateFacilityCustomTagRequestToJSONTyped(value?: CreateFacilityCustomTagRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'facility_ids': value['facility_ids'],
    };
}

